/**
 * SettingsCard — shared visual wrapper for cards inside CrmDefaultsSection.
 *
 * Built on the `lib/base/card` primitives so cards that should look the same
 * (AutoCreateCompaniesCard, CurrencyCard) share an actual component instead of
 * duplicated Tailwind classes that can drift apart over time.
 */

import type { ReactNode } from 'react';

import { Card, CardBody } from '@/lib/base/card/card';

interface SettingsCardProps {
  children: ReactNode;
  className?: string;
}

export function SettingsCard({ children, className }: SettingsCardProps) {
  return (
    <Card className={className}>
      <CardBody>{children}</CardBody>
    </Card>
  );
}
